import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    chipContent: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.colors.text[600],
    },
    chipContentIcon: {
        height: 16,
        width: 16,
    },
    chipContentDatesLabel: {
        fontWeight: 600,
    },
    chipContentDatesLabelValue: {
        fontWeight: 400,
    },
    menuContent: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
}));
//# sourceMappingURL=DateRangePickerFilterMenu.styles.js.map